import React from 'react';
import "./comingsoon.css";
import logo from "../../assets/images/mtg-logo-6.png";

const ComingSoon = () => {
  return (
    <div className="coming-soon-div">
      <img src={logo} alt="Logo" className="logo" />
      <h1 className="coming-soon-text">COMING SOON</h1>
    </div>
  );
}

export default ComingSoon;
